export default __webpack_public_path__ + "static/media/ftm.2c8cd101.png";